"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiveAsnErrorCode = exports.ReceiveAsnStatus = void 0;
/**
 * These are statuses that cannot be easily communicated with HTTP codes. They all have implications on the calling
 * service.
 */
var ReceiveAsnStatus;
(function (ReceiveAsnStatus) {
    ReceiveAsnStatus["COMPLETED"] = "COMPLETED";
    ReceiveAsnStatus["FAILED"] = "FAILED";
    ReceiveAsnStatus["FLAGGED"] = "FLAGGED";
    ReceiveAsnStatus["NOT_STARTED"] = "NOT_STARTED";
    ReceiveAsnStatus["PENDING"] = "PENDING";
    ReceiveAsnStatus["CANCELED"] = "CANCELED";
})(ReceiveAsnStatus || (exports.ReceiveAsnStatus = ReceiveAsnStatus = {}));
var ReceiveAsnErrorCode;
(function (ReceiveAsnErrorCode) {
    ReceiveAsnErrorCode["INVALID_LOCATION"] = "INVALID_LOCATION";
    ReceiveAsnErrorCode["ITEM_NOT_FOUND"] = "ITEM_NOT_FOUND";
    ReceiveAsnErrorCode["LOCKED_LOCATION"] = "LOCKED_LOCATION";
    ReceiveAsnErrorCode["ASN_CLOSED"] = "ASN_CLOSED";
    ReceiveAsnErrorCode["LOT_FEFO_LOCATION"] = "LOT_FEFO_LOCATION";
    ReceiveAsnErrorCode["ASN_NOT_FOUND"] = "ASN_NOT_FOUND";
    ReceiveAsnErrorCode["UNKNOWN"] = "UNKNOWN";
})(ReceiveAsnErrorCode || (exports.ReceiveAsnErrorCode = ReceiveAsnErrorCode = {}));
//# sourceMappingURL=ReceiveAsnResponse.js.map